import $ from 'jquery'

import colors from '../../../../lib/colors'

import options from '../../edit/options/options'

import { button, textarea } from '../../../../component/component'

export function getTableDiv(value){

  var div =
    $('<div>')
    .text(
      value.join(', ')
    )
    .css({
      padding: '8px'
    })

  return div

}

export function filterMatch(column,filter){

  if (column.value.length && filter == '*'){
    return true
  }

  if(column.value.length && filter === 'null'){
    return false
  }

  var filterValues =
    _.compact(
      _.map(
        filter.split(/\,|\/|\ /),
        function(v){
          v = v.toLowerCase()
          v = v.trim()
          return v
        },
      )
    )

  var columnValues =
    _.compact(
      _.map(
        column.value,
        function(v){
          if(_.isString(v)){
            v = v.toLowerCase()
            v = v.trim()
          }
          return v
        },
      )
    )

  var totalFilterValues = filterValues.length
  var totalFilterMatches = 0

  for(var i in filterValues){
    var filterValue = filterValues[i]
    for(var j in columnValues){
      var columnValue = columnValues[j]
      if(_.includes(columnValue,filterValue)){
        totalFilterMatches++
      }
    }
  }

  if(totalFilterMatches >= totalFilterValues){
    return true
  } else {
    return false
  }

}

export function getFormField(o,p,field){

  var format = function(value){
    value = value.join(', ')
    return value
  }

  var parse = function(value){
    value = _.compact(_.map(value.split(','),function(v){return v.trim()}))
    return value
  }

  var validate = function(value){
    if(
      value.length ||
      field.optional
    ){
      p.change(field,value,true)
      labelDiv.setColor(colors.white)
      return true
    } else {
      p.change(field,value,false)
      labelDiv.setColor(colors.red.s_500)
      return false
    }
  }

  var last = null
  var select = function(){
    var values = last || field.value
    var name = p.model.getName()
    options(o,field,values,name,function(value){
      last = parse(value)
      inputDiv.val(value)
      validate(parse(value))
    })
  }

  var labelDiv =
    button(field.id,null,true)
    .css({
      display: 'block',
      paddingRight: '20px',
    })

  var editDiv =
    button(null,'fi-pencil',false,colors.white)
    .css({
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      borderTop: `1px solid ${colors.black}`,
      borderBottom: `1px solid ${colors.black}`,
    })
    .click(select)

  var disabled = field.options ? true : false || field.edit ? false : true

  var inputDiv =
    textarea(disabled)
    .attr({
      multiline: true,
      rows: 5,
    })
    .val(
      format(field.value)
    )
    .on('input',function(){
      var value = inputDiv.val()
      validate(parse(value))
      console.log(parse(value))
    })

  var div =
    $('<div>')
    .css({
      position: 'relative'
    })
    .append(
      labelDiv,
      inputDiv,
    )

  if(field.options && field.edit){
    div.append(editDiv)
  }

  requestAnimationFrame(function(){
    var value = inputDiv.val()
    validate(parse(value))
  })

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/type/list/list.js